import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'aphrodite'
import { Link } from 'react-router-dom'
import { Container, Row } from 'reactstrap'

import style from './style'

export const Sitemap = props => {
  const sitemap = props.sitemap.slice(0, props.sitemap.length - 1)
  const currentRoute = props.sitemap[props.sitemap.length - 1]
  return (
    <Row tag="section" className={css(style.main.wrapper)}>
      <Container>
        <header>
          <ul className={`d-flex ${css(style.list.list)}`}>
            {sitemap.map((route, index) => (
              <li key={index} className={css(style.list.listItem)}>
                <Link to={route.url} className={css(style.list.link)}>
                  {route.title}
                </Link>
              </li>
            ))}
            <li>{currentRoute.title}</li>
          </ul>
          <h2 className={css(style.headers.h2)}>{currentRoute.title}</h2>
        </header>
      </Container>
    </Row>
  )
}

Sitemap.propTypes = {
  sitemap: PropTypes.array.isRequired
}

export default Sitemap



// WEBPACK FOOTER //
// ./src/components/partials/Sitemap/index.js